<template>
  <v-container>
    <br />
    <v-row v-for="(item, index) in contactList" :key="index">
      <v-col cols="12">
        <b style="font-size: 26px">ຕິດຕໍ່ເຮົາ</b>
        <div
          v-html="item?.our_company_name"
          class="pt-2 text-xl-h6 text-sm-caption text-md-h6 text-lg-h6"
        ></div>
      </v-col>
      <v-col cols="12" sm="5">
        <v-row>
          <v-col cols="2">
            <v-icon color="#9e1c20" class="elevation-4 pa-3 rounded-circle">
              mdi-map-marker</v-icon
            ></v-col
          >
          <v-col cols="10">
            <b>ສະຖານທີ່</b>
            <div v-html="item?.address"></div
          ></v-col>
          <v-col cols="2">
            <v-icon color="#9e1c20" class="elevation-4 pa-3 rounded-circle">
              mdi-phone-outline</v-icon
            ></v-col
          >
          <v-col cols="10">
            <b>ຊ່ອງທາງການຕິດຕໍ່</b>
            <div>{{ item?.tel }}</div>
            <div>{{ item?.email }}</div>
            <div>{{ item?.fax }}</div></v-col
          >
          <v-col cols="2">
            <v-icon color="#9e1c20" class="elevation-4 pa-3 rounded-circle">
              mdi-link</v-icon
            ></v-col
          >
          <v-col cols="10">
            <v-row>
              <v-col cols="12" style="padding-bottom: 0">
                <b>Social Media</b></v-col
              >
              <v-col cols="12" style="padding-top: 0">
                <span v-for="(social, indexso) in socialList" :key="indexso">
                  <v-icon
                    v-if="
                      socialIcons[social.social_type_name]?.icon.includes(
                        'mdi-'
                      )
                    "
                    :color="socialIcons[social.social_type_name].color"
                    @click="
                      GoToDeepLink(social.social_url, social.social_type_name)
                    "
                    class="mx-2"
                  >
                    {{ socialIcons[social.social_type_name].icon }}
                  </v-icon>
                  <img
                    v-else
                    :src="socialIcons[social.social_type_name].icon[0]"
                    :alt="social.social_type_name"
                    class="social-icon mx-1"
                    @click="
                      GoToDeepLink(social.social_url, social.social_type_name)
                    "
                  /> </span
              ></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="7"
        ><iframe
          :src="item.src"
          style="width: 100%; height: 100%"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe
      ></v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      countryCode: "+856",
      socialIcons: {
        Facebook: {
          icon: [require("../../assets/icon/Facebook.png")],
          color: "blue",
        },
        Instagram: {
          icon: [require("../../assets/icon/Instagram.png")],
          color: "blue",
        },
        Tiktok: {
          icon: [require("../../assets/icon/Tiktok.png")],
          color: "blue",
        },
        Line: { icon: [require("../../assets/icon/Linee.png")], color: "blue" },
        Tiktok: {
          icon: [require("../../assets/icon/Tiktok.png")],
          color: "blue",
        },
        Youtube: {
          icon: [require("../../assets/icon/Youtube_icon.png")],
          color: "red",
        },
        Whatsapp: {
          icon: [require("../../assets/icon/Whtasapp.png")],
          color: "green",
        },
        Messager: {
          icon: [require("../../assets/icon/Linee.png")],
          color: "blue",
        },
      },
    };
  },
  computed: {
    ...mapGetters("contactStore", ["contactList", "socialList"]),
  },

  methods: {
    ...mapActions("contactStore", ["GetContact", "GetSocial"]),
    GoToDeepLink(item, name) {
      console.log("item,ite", name === "Whatsapp");

      try {
        if (name === "Whatsapp") {
          const formattedNumber = item.replace(/\s+/g, "");
          const whatsappNumber = `${this.countryCode.replace(
            "+",
            ""
          )}${formattedNumber}`;
          const whatsappLink = `https://wa.me/${whatsappNumber}`;
          window.open(whatsappLink, "_blank");
        } else {
          window.open(item, "_blank");
        }
      } catch (error) {
        this.$swal({
          text: error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.response?.data?.message
            ? error?.response?.data?.message
            : JSON.stringify(error),
          type: "error",
          timerProgressBar: true,
          showConfirmButton: true,
        });
      }
    },
    GoToDeepWhatApp(item) {
      console.log("asdas");

      try {
        const formattedNumber = item.replace(/\s+/g, "");
        const whatsappNumber = `${this.countryCode.replace(
          "+",
          ""
        )}${formattedNumber}`;
        const whatsappLink = `https://wa.me/${whatsappNumber}`;
        window.open(whatsappLink, "_blank");
      } catch (error) {
        this.$swal({
          text: error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.response?.data?.message
            ? error?.response?.data?.message
            : JSON.stringify(error),
          type: "error",
          timerProgressBar: true,
          showConfirmButton: true,
        });
      }
    },
  },
  async mounted() {
    await this.GetContact();
    await this.GetSocial();
  },
};
</script>
<style scoped>
.group {
  display: flex;
  flex: 1;
  justify-content: space-around;
}
.social-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

/* .d-flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.align-items-center {
  align-items: center;
}
.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
} */
</style>
